import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import WriterSidebar from '../components/Writer/ui/Sidebar';
import Header from '../components/MasterAdmin/ui/Header';
import { recordAdminClientActivity } from '../services/MasterAdmin/EmployeeManagementService';

const WriterLayout: React.FC = () => {
  const location = useLocation();

  const getPageTitle = (pathname: string) => {
    if (pathname === '/writer/dashboard') return 'Dashboard';
    if (pathname === '/writer/notifications') return 'Notifications';
    if (pathname === '/writer/doctor-blogs') return 'Doctor Blogs';
    if (pathname === '/writer/doctor-blog-categories') return 'Doctor Blog Categories';
    if (pathname === '/writer/blogs') return 'Health Blogs';
    if (pathname === '/writer/blogs/create') return 'Create Blog';
    if (pathname.startsWith('/writer/blogs/edit/')) return 'Edit Blog';
    if (pathname.startsWith('/writer/blogs/view/')) return 'View Blog';
    if (pathname === '/writer/blogs/categories') return 'Blog Categories';
    if (pathname === '/writer/awareness') return 'Health Awareness';
    if (pathname === '/writer/awareness/create') return 'Create Awareness Event';
    if (pathname.startsWith('/writer/awareness/edit/')) return 'Edit Awareness Event';
    if (pathname.startsWith('/writer/awareness/sections/')) return 'Awareness Sections';
    return 'Writer';
  };

  const pageTitle = getPageTitle(location.pathname);

  useEffect(() => {
    recordAdminClientActivity({
      action: 'PAGE_VIEW',
      category: 'navigation',
      path: location.pathname,
      pageName: pageTitle,
      performedAction: 'Viewed page',
      summary: `Viewed page — ${pageTitle}`,
    }).catch(() => {
      /* best-effort */
    });
  }, [location.pathname, pageTitle]);

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
      <WriterSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title={pageTitle} />
        <main className="flex-1 overflow-y-auto p-6 dark:text-gray-100">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default WriterLayout;

